export {};
declare global {
  interface String {
    toTitleCase(): string;
  }
}

String.prototype.toTitleCase = function () {
  /** Work for kebab-case, snake_case, PascalCase, camelCase */
  const splitWords = this.replace(/[_-]/g, " ") // Replace underscores and hyphens with spaces
    .replace(/([a-z])([A-Z])/g, "$1 $2") // Add space between lowercase and uppercase letters
    .toLowerCase() // Convert the string to lowercase
    .split(/\s+/); // Split by spaces

  return splitWords
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};
